import { Component, inject, OnInit } from "@angular/core";
import { SVG_ICONS } from "../../models/icons";
import { ActivatedRoute, Router } from "@angular/router";
import { MasterService } from "../../serivces/master.service";
import { SharedModule } from "../../shared/shared.module";
import { SanitizerPipe } from "@frontend/app/pipes/sanitizer.pipe";
@Component({
  selector: "app-profile-details",
  imports: [SharedModule, SanitizerPipe],
  templateUrl: "./profile-details.component.html",
  styleUrl: "./profile-details.component.scss",
})
export class ProfileDetailsComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private masterService = inject(MasterService);

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params["StudentID"] && params["StudentID"] > 0) {
        const StudentID = +params["StudentID"];
        this.studentID = StudentID;
        this.getStudentDetailsByID();
      }
    });
    this.attendanceRate = (this.presentDays / this.totalDays) * 100;
    this.getStudentAttendanceWeekly();
  }
  readonly SVG_ICONS = SVG_ICONS;
  presentDays = 18;
  totalDays = 25;
  attendanceRate = 0;
  weight = 65;
  heightFeet = 5.3;
  bmi = 0;
  studentID = 0;
  classID = 0;
  studentDetails: any;
  data = Array(2).fill({
    Member: "Palak Pitroda",
    Phone: "9876543210",
    TxnID: "PAY-001",
    Plan: "3 Months – Gold",
    Date: "07-06-25",
    Center: "Ahmedabad East",
    Mode: "UPI",
    Amount: "₹ 25,00,251",
    Status: "PAID",
    image: "/profile.png",
  });
  attachmentData = Array(2).fill({
    name: "Health Certificate",
    Date: "23 Jan 2023",
  });
  performanceData = Array(2).fill({
    Metric: "BMI",
    Initial: "22.4",
    LastWeek: "22.6",
    Current: "22.6",
  });
  packageDetails: any;
  attendanceData: any;

  getStudentDetailsByID() {
    this.masterService.getStudentByID(this.studentID).subscribe((res: any) => {
      const { data } = res;
      this.studentDetails = data;

      if (this.studentDetails.packageSubscriptions?.[0]?.packageDetails) {
        this.packageDetails = this.studentDetails.packageSubscriptions[0].packageDetails;
      }

      if (this.studentDetails.classEnrollments?.[0]?.ClassID) {
        // If ClassID is an array, filter it, otherwise use it as is
        this.classID = Array.isArray(this.studentDetails.classEnrollments[0].ClassID)
          ? this.studentDetails.classEnrollments[0].ClassID.filter((item: any) => item?.IsActive)[0]?.ID
          : this.studentDetails.classEnrollments[0].ClassID;
      }

      this.calculateBMI();
    });
  }

  getStudentAttendanceWeekly() {
    this.masterService.getStudentAttendanceWeekly(this.classID, "2025-08-18").subscribe((res: any) => {
      this.attendanceData = res;
    });
  }

  editStudent() {
    this.router.navigate(["/add-student"], { queryParams: { StudentID: this.studentID } });
  }

  calculateBMI() {
    const heightInMeters = this.studentDetails.Height / 100;
    this.bmi = this.studentDetails.Weight / (heightInMeters * heightInMeters);
  }
}
